<template>
  <div>
    <v-card
      flat
      outlined
      tile
    >
      <v-app-bar
        dense
        flat
      >
        <v-btn
          icon
          color="primary"
          @click="goBack()"
        >
          <v-icon>mdi-keyboard-backspace</v-icon>
        </v-btn>

        <v-toolbar-title>
          {{ accountInfo.name }}
          <v-icon
            v-if="accountInfo.active"
            small
            color="success"
          >
            mdi-shield-check
          </v-icon>
        </v-toolbar-title>

        <v-spacer />
        <v-row
          justify="end"
          no-gutters
        >
          <v-col cols="auto">
            <v-chip
              v-if="accountInfo.activeStatus"
              label
              color="success"
              class="mr-2"
            >
              Active
            </v-chip>
            <v-chip
              v-else
              label
              color="error"
              class="mr-2"
            >
              In-active
            </v-chip>
          </v-col>
          <v-col cols="auto">
            <v-chip
              v-if="accountInfo.verified"
              label
              color="success"
              class="mr-2"
            >
              Verified
            </v-chip>
            <v-chip
              v-else
              label
              color="error"
              class="mr-2"
            >
              Not verified
            </v-chip>
          </v-col>
          <v-col
            v-if="!loader"
            cols="auto"
          >
            <account-options
              :account="accountInfo"
              @reload="init()"
            />
          </v-col>
        </v-row>
        <template v-slot:extension>
          <v-tabs
            v-model="selectedTab"
            centered
          >
            <v-tabs-slider color="primary" />
            <v-tab
              v-for="tab in tabs"
              :key="tab.name"
            >
              {{ tab.name }}
            </v-tab>
          </v-tabs>
        </template>
      </v-app-bar>
      <v-divider />
      <v-sheet>
        <v-tabs-items v-model="selectedTab">
          <v-tab-item
            v-for="tab in tabs"
            :key="tab.name"
          >
            <component :is="tab.component" />
          </v-tab-item>
        </v-tabs-items>
      </v-sheet>
    </v-card>
  </div>
</template>

<script>
import { failure } from "@/mixins/common";
import Stores from "./StoreList";
import Gallery from "../gallery/List.vue";
import AccountOptions from "./AccountOptions";
import Contactless from "@/components/contactless/Contactless";

export default {
	components: {
		Stores,
		Gallery,
		AccountOptions,
    Contactless
	},
	mixins: [failure],
	data() {
		return {
			loader: false,
			accountInfo: {},
			selectedTab: 0,
			tabs: [
				{
					name: "Stores",
					component: "stores"
				},
				{
					name: "Gallery",
					component: "gallery"
				},
				{
					name: "Contactless",
					component: "contactless"
				}
			]
		};
	},
	created() {
		this.init();
	},
	methods: {
		getAccount() {
			this.loader = true;
			let accountId = this.$route.params.accountId;
			let url = `${this.ADMIN_API_URL}/accounts/${accountId}`;
			this.$http.get(url).then(
				function(res) {
					this.accountInfo = res.body;
          localStorage.setItem("account_info", JSON.stringify(this.accountInfo));
					this.loader = false;
				},
				function(failure) {
					this.handleFailure(failure);
          this.goBack(); // goto list page on error
				}
			);
		},
		goBack: function() {
			this.$router.push({ path: "/accounts" });
		},
		init: function() {
			this.getAccount();
			this.$store.commit("setTitle", "Account Details");
		}
	}
};
</script>
